export default __webpack_public_path__ + "static/media/6_long.0bdd8b4e.svg";